// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"SubHeader_wrapper__2KRri","content":"SubHeader_content__Srm36","btnBack":"SubHeader_btnBack__1dbAh","line":"SubHeader_line__3YLeR"};